document.addEventListener('DOMContentLoaded', () => {

            /* =========================================================
               HERO SLIDER
               - Autoplay: 2000ms
               - Pauses while hovered
               - Mouse/touch/pointer dragging
               - Glass thumbnail dots + arrows
               - Hotspots only on slide 1
            ========================================================= */

            const hero = document.querySelector('#hero');

            if (hero) {

                const slides = [...hero.querySelectorAll('.hero-slide-bg')];
                const copies = [...hero.querySelectorAll('.hero-slide-copy')];
                const dots = [...hero.querySelectorAll('.hero-dot')];
                const hotspotsWrap = hero.querySelector('#heroHotspots');
                const hotspots = [...hero.querySelectorAll('.hotspot')];
                const prevBtn = hero.querySelector('#heroPrev');
                const nextBtn = hero.querySelector('#heroNext');
                const progress = hero.querySelector('#heroProgress');

                const IMG_W = 1536;
                const IMG_H = 1094;
                const AUTOPLAY = 2000;

                let current = 0;
                let timer = null;
                let isHovering = false;

                let isDragging = false;
                let dragStartX = 0;
                let dragDeltaX = 0;
                let suppressClick = false;


                /* ---------------------------------------------------------
                   PROGRESS BAR
                --------------------------------------------------------- */

                function restartProgress() {

                    if (!progress) return;

                    progress.style.animation = 'none';

                    void progress.offsetWidth;

                    progress.style.animation =
                        `heroProgress ${AUTOPLAY}ms linear forwards`;

                    if (isHovering) {
                        progress.style.animationPlayState = 'paused';
                    }
                }


                /* ---------------------------------------------------------
                   HOTSPOT POSITIONING
                --------------------------------------------------------- */

                function updateHotspots() {

                    if (!hotspotsWrap) return;

                    const visible = current === 0;

                    hotspotsWrap.style.opacity =
                        visible ? '1' : '0';

                    hotspotsWrap.style.visibility =
                        visible ? 'visible' : 'hidden';

                    hotspotsWrap.style.pointerEvents =
                        visible ? 'auto' : 'none';


                    const cw = hero.clientWidth;
                    const ch = hero.clientHeight;

                    const scale = Math.max(
                        cw / IMG_W,
                        ch / IMG_H
                    );

                    const dw = IMG_W * scale;
                    const dh = IMG_H * scale;

                    const posX =
                        window.matchMedia('(max-width: 768px)').matches
                            ? 0.68
                            : 1;

                    const offX = (cw - dw) * posX;
                    const offY = (ch - dh) * 0.5;


                    hotspots.forEach(hotspot => {

                        const fx = parseFloat(
                            hotspot.dataset.x
                        );

                        const fy = parseFloat(
                            hotspot.dataset.y
                        );

                        hotspot.style.left =
                            (offX + fx * dw) + 'px';

                        hotspot.style.top =
                            (offY + fy * dh) + 'px';

                    });

                }


                /* ---------------------------------------------------------
                   SET SLIDE
                --------------------------------------------------------- */

                function setSlide(index) {

                    const next =
                        (index + slides.length) %
                        slides.length;

                    current = next;


                    slides.forEach((slide, i) => {

                        slide.classList.toggle(
                            'active',
                            i === current
                        );

                    });


                    copies.forEach((copy, i) => {

                        copy.classList.toggle(
                            'active',
                            i === current
                        );

                    });


                    dots.forEach((dot, i) => {

                        const active =
                            i === current;

                        dot.classList.toggle(
                            'active',
                            active
                        );

                        dot.setAttribute(
                            'aria-current',
                            active ? 'true' : 'false'
                        );

                    });


                    hotspots.forEach(hotspot => {
                        hotspot.classList.remove('active');
                    });


                    updateHotspots();
                    restartProgress();

                }


                /* ---------------------------------------------------------
                   AUTOPLAY
                --------------------------------------------------------- */

                function startAutoplay() {

                    clearInterval(timer);

                    if (!isHovering) {

                        timer = setInterval(() => {

                            setSlide(current + 1);

                        }, AUTOPLAY);

                    }

                }


                function stopAutoplay() {

                    clearInterval(timer);

                    timer = null;

                }


                function goTo(index) {

                    setSlide(index);

                    startAutoplay();

                }


                /* ---------------------------------------------------------
                   HERO CONTROLS
                   Keep controls separate from drag handling
                --------------------------------------------------------- */

                const controls =
                    hero.querySelector('.hero-controls');


                controls?.addEventListener(
                    'pointerdown',
                    e => e.stopPropagation()
                );

                controls?.addEventListener(
                    'pointermove',
                    e => e.stopPropagation()
                );

                controls?.addEventListener(
                    'pointerup',
                    e => e.stopPropagation()
                );


                /* ---------------------------------------------------------
                   PREVIOUS BUTTON
                --------------------------------------------------------- */

                prevBtn?.addEventListener('click', e => {

                    e.preventDefault();
                    e.stopPropagation();

                    goTo(current - 1);

                });


                /* ---------------------------------------------------------
                   NEXT BUTTON
                --------------------------------------------------------- */

                nextBtn?.addEventListener('click', e => {

                    e.preventDefault();
                    e.stopPropagation();

                    goTo(current + 1);

                });


                /* ---------------------------------------------------------
                   THUMBNAIL DOTS
                --------------------------------------------------------- */

                dots.forEach((dot, index) => {

                    dot.addEventListener('click', e => {

                        e.preventDefault();
                        e.stopPropagation();

                        goTo(index);

                    });

                });


                /* ---------------------------------------------------------
                   PAUSE ON HOVER
                --------------------------------------------------------- */

                hero.addEventListener('mouseenter', () => {

                    isHovering = true;

                    stopAutoplay();

                    hero.classList.add('is-paused');

                    if (progress) {
                        progress.style.animationPlayState =
                            'paused';
                    }

                });


                /* ---------------------------------------------------------
                   RESUME AFTER HOVER
                --------------------------------------------------------- */

                hero.addEventListener('mouseleave', () => {

                    isHovering = false;

                    hero.classList.remove('is-paused');

                    startAutoplay();

                    restartProgress();

                });


                /* ---------------------------------------------------------
                   POINTER DOWN / DRAG START
                --------------------------------------------------------- */

                hero.addEventListener('pointerdown', e => {

                    if (
                        e.target.closest('.hero-controls')
                    ) {
                        return;
                    }

                    if (
                        e.pointerType === 'mouse' &&
                        e.button !== 0
                    ) {
                        return;
                    }


                    isDragging = true;

                    dragStartX = e.clientX;
                    dragDeltaX = 0;
                    suppressClick = false;


                    hero.setPointerCapture?.(
                        e.pointerId
                    );


                    hero.style.cursor = 'grabbing';

                    stopAutoplay();

                });


                /* ---------------------------------------------------------
                   POINTER MOVE
                --------------------------------------------------------- */

                hero.addEventListener('pointermove', e => {

                    if (!isDragging) return;

                    dragDeltaX =
                        e.clientX - dragStartX;


                    if (
                        Math.abs(dragDeltaX) > 8
                    ) {
                        suppressClick = true;
                    }

                });


                /* ---------------------------------------------------------
                   POINTER UP / SWIPE
                --------------------------------------------------------- */

                hero.addEventListener('pointerup', e => {

                    if (!isDragging) return;

                    isDragging = false;


                    hero.releasePointerCapture?.(
                        e.pointerId
                    );


                    hero.style.cursor = '';


                    if (
                        Math.abs(dragDeltaX) > 55
                    ) {

                        setSlide(
                            current +
                            (
                                dragDeltaX < 0
                                    ? 1
                                    : -1
                            )
                        );

                    }


                    dragDeltaX = 0;


                    if (!isHovering) {
                        startAutoplay();
                    }

                });


                /* ---------------------------------------------------------
                   POINTER CANCEL
                --------------------------------------------------------- */

                hero.addEventListener(
                    'pointercancel',
                    () => {

                        isDragging = false;
                        dragDeltaX = 0;

                        hero.style.cursor = '';

                        if (!isHovering) {
                            startAutoplay();
                        }

                    }
                );


                /* ---------------------------------------------------------
                   HOTSPOTS
                --------------------------------------------------------- */

                hotspots.forEach(hotspot => {

                    hotspot.addEventListener(
                        'click',
                        e => {

                            e.stopPropagation();


                            if (suppressClick) {

                                e.preventDefault();

                                suppressClick = false;

                                return;

                            }


                            const wasActive =
                                hotspot.classList.contains(
                                    'active'
                                );


                            hotspots.forEach(item => {

                                item.classList.remove(
                                    'active'
                                );

                            });


                            if (!wasActive) {

                                hotspot.classList.add(
                                    'active'
                                );

                            }

                        }
                    );

                });


                /* ---------------------------------------------------------
                   CLOSE HOTSPOT WHEN CLICKING OUTSIDE
                --------------------------------------------------------- */

                document.addEventListener('click', e => {

                    if (!hero.contains(e.target)) {

                        hotspots.forEach(hotspot => {

                            hotspot.classList.remove(
                                'active'
                            );

                        });

                    }

                });


                /* ---------------------------------------------------------
                   RESIZE
                --------------------------------------------------------- */

                window.addEventListener(
                    'resize',
                    updateHotspots
                );


                /* ---------------------------------------------------------
                   INITIALIZE HERO
                --------------------------------------------------------- */

                updateHotspots();

                setSlide(0);

                startAutoplay();

            }


            /* =========================================================
               PRODUCT OPTIONS
               - Color swatches
               - Size buttons
            ========================================================= */


            /* ---------------------------------------------------------
               COLOR SWATCHES
            --------------------------------------------------------- */

            document
                .querySelectorAll('.color-swatches .swatch')
                .forEach(btn => {

                    btn.addEventListener('click', () => {

                        document
                            .querySelectorAll(
                                '.color-swatches .swatch'
                            )
                            .forEach(b => {

                                b.classList.remove(
                                    'active'
                                );

                            });


                        btn.classList.add('active');


                        const colorName =
                            document.getElementById(
                                'colorName'
                            );


                        if (colorName) {

                            colorName.textContent =
                                btn.dataset.color;

                        }

                    });

                });


            /* ---------------------------------------------------------
               SIZE OPTIONS
            --------------------------------------------------------- */

            document
                .querySelectorAll('.size-options .size-btn')
                .forEach(btn => {

                    btn.addEventListener('click', () => {

                        document
                            .querySelectorAll(
                                '.size-options .size-btn'
                            )
                            .forEach(b => {

                                b.classList.remove(
                                    'active'
                                );

                            });


                        btn.classList.add('active');


                        const sizeName =
                            document.getElementById(
                                'sizeName'
                            );


                        if (sizeName) {

                            sizeName.textContent =
                                btn.textContent;

                        }

                    });

                });

        });


        /* ============================================================
           GSAP PRODUCT VERTICAL SNAP SCROLL
        
           - Product section pins to viewport
           - One product occupies one viewport
           - Product enters from bottom
           - Previous product exits to top
           - ScrollTrigger snap
           - Mouse wheel supported
           - Touch supported
           - Dot navigation supported
           - Desktop / tablet / mobile
        ============================================================ */

        window.addEventListener('load', () => {

            if (
                typeof gsap === 'undefined' ||
                typeof ScrollTrigger === 'undefined'
            ) {

                console.warn(
                    'GSAP / ScrollTrigger failed to load.'
                );

                return;

            }


            gsap.registerPlugin(
                ScrollTrigger
            );


            const productSection =
                document.querySelector('[id^="productFeatures-"]');


            const products =
                gsap.utils.toArray('[id^="productFeatures-"] .product-feature');


            const dots =
                gsap.utils.toArray(
                    '.product-snap-dot'
                );


            const snapDots =
                document.querySelector(
                    '.product-snap-dots'
                );


            if (
                !productSection ||
                products.length < 2
            ) {
                return;
            }


            /* =========================================================
               SECTION SETUP
            ========================================================= */

            gsap.set(productSection, {

                height: '100vh',

                position: 'relative',

                overflow: 'hidden'

            });


            /* =========================================================
               PRODUCT LAYERS
        
               Every product occupies exactly the same viewport.
            ========================================================= */

            gsap.set(products, {

                position: 'absolute',

                top: 0,
                left: 0,

                width: '100%',
                height: '100%',

                opacity: 1,

                yPercent: 0

            });


            /* =========================================================
               INITIAL PRODUCT POSITIONS
        
               Product 1:
               visible
        
               Product 2+:
               below viewport
            ========================================================= */

            products.forEach((product, index) => {

                gsap.set(product, {

                    yPercent:
                        index === 0
                            ? 0
                            : 100,

                    zIndex: index + 1

                });

            });


            /* =========================================================
               INITIAL PRODUCT CONTENT
            ========================================================= */

            products.forEach((product, index) => {

                const info =
                    product.querySelector(
                        '.product-info'
                    );


                if (!info) return;


                gsap.set(info, {

                    y:
                        index === 0
                            ? 0
                            : 70,

                    opacity:
                        index === 0
                            ? 1
                            : 0

                });

            });


            /* =========================================================
               MASTER TIMELINE
            ========================================================= */

            const tl =
                gsap.timeline({

                    defaults: {

                        ease: 'power3.inOut'

                    },


                    scrollTrigger: {

                        trigger: productSection,

                        start: 'top top',


                        /* ---------------------------------------------
                           One viewport per product transition
                        --------------------------------------------- */

                        end: () => {

                            return '+=' +
                                (
                                    window.innerHeight *
                                    (products.length - 1)
                                );

                        },


                        pin: true,

                        scrub: 0.8,

                        anticipatePin: 1,

                        invalidateOnRefresh: true,


                        /* ---------------------------------------------
                           SNAP
                        --------------------------------------------- */

                        snap: {

                            snapTo:
                                1 /
                                (
                                    products.length - 1
                                ),

                            duration: {

                                min: 0.35,

                                max: 0.75

                            },

                            delay: 0.04,

                            ease: 'power2.inOut'

                        },


                        /* ---------------------------------------------
                           ENTER
                        --------------------------------------------- */

                        onEnter: () => {

                            snapDots?.classList.add(
                                'is-visible'
                            );

                        },


                        onEnterBack: () => {

                            snapDots?.classList.add(
                                'is-visible'
                            );

                        },


                        /* ---------------------------------------------
                           LEAVE
                        --------------------------------------------- */

                        onLeave: () => {

                            snapDots?.classList.remove(
                                'is-visible'
                            );

                        },


                        onLeaveBack: () => {

                            snapDots?.classList.remove(
                                'is-visible'
                            );

                        },


                        /* ---------------------------------------------
                           ACTIVE DOT
                        --------------------------------------------- */

                        onUpdate: self => {

                            const index =
                                Math.round(
                                    self.progress *
                                    (
                                        products.length - 1
                                    )
                                );


                            dots.forEach(
                                (dot, dotIndex) => {

                                    const active =
                                        dotIndex === index;


                                    dot.classList.toggle(
                                        'active',
                                        active
                                    );


                                    dot.setAttribute(
                                        'aria-current',
                                        active
                                            ? 'true'
                                            : 'false'
                                    );

                                }
                            );

                        }

                    }

                });


            /* =========================================================
               BUILD VERTICAL PRODUCT TRANSITIONS
            ========================================================= */

            products.forEach(
                (product, index) => {

                    if (index === 0) return;


                    const previous =
                        products[index - 1];


                    const previousInfo =
                        previous.querySelector(
                            '.product-info'
                        );


                    const currentInfo =
                        product.querySelector(
                            '.product-info'
                        );


                    /* -------------------------------------------------
                       CURRENT PRODUCT
        
                       BOTTOM → TOP
                    ------------------------------------------------- */

                    tl.to(
                        product,
                        {

                            yPercent: 0,

                            duration: 1,

                            ease: 'power3.inOut'

                        },
                        index - 1
                    );


                    /* -------------------------------------------------
                       PREVIOUS PRODUCT
        
                       CURRENT → TOP
                    ------------------------------------------------- */

                    tl.to(
                        previous,
                        {

                            yPercent: -100,

                            duration: 1,

                            ease: 'power3.inOut'

                        },
                        index - 1
                    );


                    /* -------------------------------------------------
                       PREVIOUS CONTENT
        
                       Moves upward slightly
                    ------------------------------------------------- */

                    if (previousInfo) {

                        tl.to(
                            previousInfo,
                            {

                                y: -70,

                                opacity: 0,

                                duration: 0.45,

                                ease: 'power2.in'

                            },
                            index - 1
                        );

                    }


                    /* -------------------------------------------------
                       CURRENT CONTENT
        
                       Enters from bottom
                    ------------------------------------------------- */

                    if (currentInfo) {

                        tl.fromTo(
                            currentInfo,

                            {

                                y: 70,

                                opacity: 0

                            },

                            {

                                y: 0,

                                opacity: 1,

                                duration: 0.55,

                                ease: 'power3.out'

                            },

                            index - 1 + 0.25
                        );

                    }

                }
            );


            /* =========================================================
               PRODUCT SNAP DOT NAVIGATION
            ========================================================= */

            dots.forEach(
                (dot, index) => {

                    dot.addEventListener(
                        'click',
                        () => {

                            const trigger =
                                tl.scrollTrigger;


                            if (!trigger) return;


                            const progress =
                                index /
                                (
                                    products.length - 1
                                );


                            const target =
                                trigger.start +
                                (
                                    (
                                        trigger.end -
                                        trigger.start
                                    ) *
                                    progress
                                );


                            window.scrollTo({

                                top: target,

                                behavior: 'smooth'

                            });

                        }
                    );

                }
            );


            /* =========================================================
               INITIAL REFRESH
            ========================================================= */

            ScrollTrigger.refresh();

        });


        /* ============================================================
           PHILOSOPHY PARALLAX
           - Image 1
           - Image 2
           - Image 3
        ============================================================ */

        document.addEventListener(
            'DOMContentLoaded',
            () => {

                if (
                    typeof gsap === 'undefined' ||
                    typeof ScrollTrigger === 'undefined'
                ) {
                    return;
                }


                gsap.registerPlugin(
                    ScrollTrigger
                );


                /* -----------------------------------------------------
                   IMAGE 1
                ----------------------------------------------------- */

                if (
                    document.querySelector(
                        '.philosophy-float-1'
                    )
                ) {

                    gsap.to(
                        '.philosophy-float-1',
                        {

                            y: -250,

                            rotation: -5,

                            ease: 'none',

                            scrollTrigger: {

                                trigger:
                                    '.philosophy-section',

                                start:
                                    'top bottom',

                                end:
                                    'bottom top',

                                scrub: 1

                            }

                        }
                    );

                }


                /* -----------------------------------------------------
                   IMAGE 2
                ----------------------------------------------------- */

                if (
                    document.querySelector(
                        '.philosophy-float-2'
                    )
                ) {

                    gsap.to(
                        '.philosophy-float-2',
                        {

                            y: -400,

                            rotation: 6,

                            ease: 'none',

                            scrollTrigger: {

                                trigger:
                                    '.philosophy-section',

                                start:
                                    'top bottom',

                                end:
                                    'bottom top',

                                scrub: 1.3

                            }

                        }
                    );

                }


                /* -----------------------------------------------------
                   IMAGE 3
                ----------------------------------------------------- */

                if (
                    document.querySelector(
                        '.philosophy-float-3'
                    )
                ) {

                    gsap.to(
                        '.philosophy-float-3',
                        {

                            y: -320,

                            rotation: -4,

                            ease: 'none',

                            scrollTrigger: {

                                trigger:
                                    '.philosophy-section',

                                start:
                                    'top bottom',

                                end:
                                    'bottom top',

                                scrub: 1.1

                            }

                        }
                    );

                }

            }
        );

(function () {
            const section = document.getElementById('editorialSection');
            if (!section || typeof gsap === 'undefined') return;
            const cols = document.querySelectorAll('.accordion-col');
            const headerLabel = document.querySelector('.header__label');
            const headerTitle = document.querySelector('.header__title');
            const headerLine = document.querySelector('.header__line');
            
            const accordion = document.getElementById('hoverAccordion');

            /* ---------------------------------------------------------
               1. GSAP ENTRANCE ANIMATIONS
               --------------------------------------------------------- */
            const entranceTl = gsap.timeline({ defaults: { ease: 'power3.out' } });

            entranceTl
                .to(headerLabel, { opacity: 1, y: 0, duration: 0.8 }, 0.2)
                .to(headerTitle, { opacity: 1, y: 0, duration: 0.8 }, 0.35)
                .to(headerLine, { opacity: 1, scaleX: 1, duration: 0.6 }, 0.55)
                .to(accordion, { opacity: 1, y: 0, duration: 1 }, 0.5)
                .from(cols, {
                    opacity: 0,
                    y: 60,
                    duration: 0.9,
                    stagger: 0.12,
                    ease: 'power3.out'
                }, 0.6);

            /* ---------------------------------------------------------
               2. SPOTLIGHT — Background text follows mouse (GSAP)
               --------------------------------------------------------- */
            // SPOTLIGHT
            const spotlight = document.getElementById('bgTextSpotlight');

            const xTo = gsap.quickTo(spotlight, '--spot-x', {
                duration: 0.4,
                ease: 'power3.out',
                unit: 'px'
            });

            const yTo = gsap.quickTo(spotlight, '--spot-y', {
                duration: 0.4,
                ease: 'power3.out',
                unit: 'px'
            });

            section.addEventListener('mousemove', (e) => {
                const rect = section.getBoundingClientRect();

                xTo(e.clientX - rect.left);
                yTo(e.clientY - rect.top);
            });

            section.addEventListener('mouseleave', () => {
                xTo(-9999);
                yTo(-9999);
            });

            /* ---------------------------------------------------------
               3. ACCORDION HOVER LOGIC
               - Column 1 open by default
               - Hover opens the hovered column
               - All other columns close
               --------------------------------------------------------- */
            function setActive(index) {
                cols.forEach((col, i) => {
                    col.classList.toggle('is-active', i === index);
                });
            }

            // First column open by default
            setActive(0);

            // Open hovered column
            cols.forEach((col, idx) => {
                col.addEventListener('mouseenter', () => {
                    setActive(idx);
                });
            });

            /* ---------------------------------------------------------
               4. FLOATING TEXT ANIMATION (subtle ambient drift)
               --------------------------------------------------------- */
            const textRows = document.querySelectorAll('.text-row');
            textRows.forEach((row, i) => {
                gsap.to(row, {
                    x: i % 2 === 0 ? 30 : -30,
                    duration: 8 + i * 1.5,
                    ease: 'sine.inOut',
                    repeat: -1,
                    yoyo: true
                });
            });

        })();
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 767) return;

  const container = document.querySelector(".trust-badges-inner");
  if (!container) return;

  const badges = Array.from(container.querySelectorAll(".trust-badge"));
  if (badges.length <= 1) return;

  // Clone badges for seamless infinite scrolling
  badges.forEach((badge) => {
    container.appendChild(badge.cloneNode(true));
  });

  const allBadges = container.querySelectorAll(".trust-badge");

  // Start with the first badge visible
  let currentIndex = 0;
  let isAnimating = false;

  function slideTo(index) {
    if (isAnimating) return;

    isAnimating = true;
    currentIndex = index;

    gsap.to(container, {
      xPercent: -(currentIndex * 100),
      duration: 0.8,
      ease: "power2.inOut",
      onComplete: () => {
        // When we've reached the cloned set, instantly
        // jump back to the original first badge.
        if (currentIndex >= badges.length) {
          gsap.set(container, {
            xPercent: 0
          });

          currentIndex = 0;
        }

        isAnimating = false;
      }
    });
  }

  // Auto slide
  const autoScroll = gsap.timeline({
    repeat: -1,
    repeatDelay: 0.8
  });

  autoScroll.call(() => {
    slideTo(currentIndex + 1);
  }, null, 2);

  // Restart animation timing after each slide
  function startAutoScroll() {
    autoScroll.restart();
  }

  // Optional swipe support
  let startX = 0;

  container.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    autoScroll.pause();
  }, { passive: true });

  container.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const difference = startX - endX;

    if (Math.abs(difference) > 50) {
      if (difference > 0) {
        slideTo(currentIndex + 1);
      } else if (currentIndex > 0) {
        slideTo(currentIndex - 1);
      }
    }

    startAutoScroll();
  }, { passive: true });

  // Handle resizing
  window.addEventListener("resize", () => {
    if (window.innerWidth > 767) {
      gsap.killTweensOf(container);
      gsap.set(container, { clearProps: "transform" });
    }
  });
});